module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-minus.f15c6b75.svg";